import Moment from "react-moment";
import React, {Fragment} from "react";

export const DateFormat = function(props) {
    let format = 'YYYY/MM/DD';

    if(props.value === null) {
        return <Fragment>N/A</Fragment>;
    }

    if(typeof props.format !== 'undefined') {
        format = props.format;
    }

    return <Moment date={props.value} format={format} />;
};
